<template>
    <div class="shop-checkout">
        <div v-if="showDemoStuff" style="background-color: goldenrod; border: 3px dashed darkgoldenrod">
            Set Demo-Cookies for
            <button class="button" @click="setCartButton">DACH_cart</button>
            <button class="button" @click="setWishlistButton">DACH_wishlist</button>
        </div>
        <shop-cart v-if="cart"/>
        <shop-wishlist v-if="!cart"/>
    </div>
</template>

<script>
import {CONSTANTS} from "../shared/constants";
import ShopCart from "../views/shop-cart/shop-cart.vue";
import ShopWishlist from "../views/shop-wishlist/shop-wishlist.vue";
import {cookieUtils} from "@utilities/cookie-utils/cookie-utils";

export default {
        name: "shop-checkout",
        components: {ShopWishlist, ShopCart},
        props: {
            _mode: String
        },
        computed: {
            showDemoStuff() {
                // nur anzeigen, wenn aktuele domain ddev.site enthlät
                return window.location.hostname.includes('ddev.site');
            },
            cart() {
                return this._mode === CONSTANTS.mode.cart;
            },
            authenticated() {
                return this.$store.getters.authenticated;
            }
        },
        methods: {
            setCartButton() {
                cookieUtils.setCookie('cart_DACH', 'sample#169126$sample#169127$sample#160034$sample#122863$sample#122868$sample#160626$sample#209129$sample#121623$sample#209321$sample#209235$sample#159533$sample#208262$sample#159993$sample#209265$sample#209259$sample#209295$sample#161684');
                window.location.reload();
            },
            setWishlistButton() {
                cookieUtils.setCookie('wishlist_DACH', 'decoboard#203351$decoboard#171605$decoboard#171600$decoboard#171704$decoboard#171673$decoboard#171722$sample#169126$sample#169127$sample#160034$decorset#Dekorpalette1#166676#24418#24293#42476#24488#24399$decorset#Dekorpalette 1#46230#24456#42466#111227#111228#111268#111229#135127#135128#135131#166676$decor#24460$sample#122863$decor#24461$sample#122868$decor#24449$sample#160626$sample#209129$structure#24056$sample#121623$sample#209321$decoboard#171706$rawboard#137516$sample#209235$rawboard#137596$decoboard#171724$sample#159533$sample#208262$sample#159993$rawboard#137548$sample#209265$sample#209259$sample#209295$decoboard#171690$sample#161684');
                window.location.reload();
            }
        },
        created() {
            this.$store.dispatch("login");
        }
    }
</script>
